export default __webpack_public_path__ + "images/0911f04dc44585b9a5ede652677cfd7a-greeting-card.svg";